<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="box info-box">
        <div class="box-header with-border">
          Filter 
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3">
              <label for="date">Date</label>
              <input type="date" v-model="emiDate" name="emiDate" class="form-control" placeholder="EMI Date">
            </div>
            <div class="col-md-3">
              <label for="date">Start Date</label>
              <input type="date" v-model="emiStartDate" name="emiStartDate" class="form-control" placeholder="EMI Start Date">
            </div>
            <div class="col-md-3">
              <label for="date">End Date</label>
              <input type="date" v-model="emiEndDate" name="emiEndDate" class="form-control" placeholder="EMI End Date">
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Guarantor <span class="red">*</span></label>
                <select
                  v-model="enableGuarantor"
                  name="enableGuarantor"
                  class="form-control"
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">

              <div class="form-group">
                <label
                  >Recovery type
                  <span class="red">*</span></label
                >
                <select
                  v-model="recoveryType"
                  name="recoveryType"
                  class="form-control"
                >
                  <option value="">All</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="BiWeekly">BiWeekly</option>
                  <option value="HalfMonth">Half Month</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly">Yearly</option>
                  <option value="OneTime">One Time</option>

                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- /.box-body -->
      </div>
        <!-- Application buttons -->
        <div class="box info-box">
          <div class="box-header text-center">
            <h3 class="box-title"><i class="fa fa-info"></i> Cibil Details</h3>
          </div>
          <div class="box-body text-center">
            <a class="btn btn-app box-widget box-red" href="https://hub.crifhighmark.com/Inquiry/Inquiry/WebPortal.action">
              <i class="fa fa-address-card-o"></i> High Mark
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo"> 
              <i class="fa fa-address-card"></i> Equifax
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo">
              <i class="fa fa-id-card-o"></i> Experian
            </a>
            <a class="btn btn-app box-widget box-red" @click="viewInfo">
              <i class="fa fa-id-card"></i> TransUnion
            </a>
            <br>
            <a  :href="`${this.$axios.defaults.baseURL}/cibilreport/highmark/export/excel?recoveryType=${recoveryType}&emiDate=${emiDate}&emiStartDate=${emiStartDate}&emiEndDate=${emiEndDate}`" class="btn btn-box-tool">
              <i class="fa fa-file-excel-o"></i> Download Individual Loan Excel
            </a>
            <a  :href="`${this.$axios.defaults.baseURL}/cibilreport/highmarkone/export/excel?recoveryType=${recoveryType}&emiDate=${emiDate}&emiStartDate=${emiStartDate}&emiEndDate=${emiEndDate}&enableGuarantor=${enableGuarantor}`" class="btn btn-box-tool">
              <i class="fa fa-file-excel-o"></i> Download New Individual Loan Excel
            </a>
            <a  :href="`${this.$axios.defaults.baseURL}/cibilreport/highmark/group/export/excel?recoveryType=${recoveryType}&emiDate=${emiDate}&emiStartDate=${emiStartDate}&emiEndDate=${emiEndDate}`" class="btn btn-box-tool">
              <i class="fa fa-file-excel-o"></i> Download Group Loan Excel
            </a>
            <a  :href="`${this.$axios.defaults.baseURL}/cibilreport/highmark/comman/export/excel?recoveryType=${recoveryType}&emiDate=${emiDate}&emiStartDate=${emiStartDate}&emiEndDate=${emiEndDate}`" class="btn btn-box-tool">
              <i class="fa fa-file-excel-o"></i>Comman MFI Loan Excel
            </a>
            <!-- <a class="btn btn-app">
              <i class="fa fa-check-square-o"></i> Check
            </a> -->
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Cibil',
  data () {
    return {
      emiDate: new Date().toISOString().slice(0, 10),
      emiStartDate: '',
      emiEndDate: '',
      recoveryType: '',
      enableGuarantor: 'false'
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewInfo () {
      Swal.fire('Cibil Score!', '<b>For Cibil Feature Please Contact Or whatsapp on +91-7017109788, 9911551344.</b>', 'info')
    }
  }
}
</script>
<style scoped>
  table.v-table thead th {
      font-size: 20px;
 }
 .widget-user .widget-user-header {
    height: 70px;
 }
 .box-widget {
   border-radius:10px;
   box-shadow: 0px 0px 4px gray;
 }
 .widget-user-desc-b {
   padding-bottom: 10px;
 }
 .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .widget-user .widget-user-header {
    height: 85px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// Cibil.vue?5f9599aa